<template>
  <div id="galerie" class="section section-contacts">
    <div class="container">
      <div class="md-layout">
        <div class="md-layout-item md-size-100 md-xsmall-size-100 mx-auto">
          <h2 class="text-center title">Galerie</h2>
          <div class="md-layout">
            <div class="md-layout-item md-size-80 mx-auto md-small-size-100">
              <md-card>
                <carousel
                  :per-page="1"
                  loop
                  :speed="700"
                  autoplay
                  :autoplay-timeout="5000"
                  :mouse-drag="false"
                  navigationEnabled
                  navigationNextLabel="<i class='material-icons'>keyboard_arrow_right</i>"
                  navigationPrevLabel="<i class='material-icons'>keyboard_arrow_left</i>"
                >
                  <slide v-for="bild in bilder" :key="bild">
                    <img :src="bild" />
                  </slide>
                </carousel>
              </md-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bilder: [
        require("@/assets/img/ferienhaus_debontje_greetsiel_unten_1.jpg"),
        require("@/assets/img/ferienhaus_debontje_greetsiel_kueche_01.jpg"),
        require("@/assets/img/ferienhaus_debontje_greetsiel_treppe_1.jpg"),
        require("@/assets/img/ferienhaus_debontje_greetsiel_schlafzimmer_unten_01.jpg"),
        require("@/assets/img/ferienhaus_debontje_greetsiel_schlafzimmer_unten_02.jpg"),
        require("@/assets/img/ferienhaus_debontje_greetsiel_bad_oben_1.jpg"),
        require("@/assets/img/ferienhaus_debontje_greetsiel_schlafzimmer_oben_gross_01.jpg"),
        require("@/assets/img/ferienhaus_debontje_greetsiel_schlafzimmer_oben_links_01.jpg"),
        require("@/assets/img/ferienhaus_debontje_greetsiel_schlafzimmer_oben_links_03.jpg"),
        require("@/assets/img/ferienhaus_debontje_greetsiel_gartenblick.jpg"),
        require("@/assets/img/ferienhaus_debontje_greetsiel_garten_01.jpg"),
        require("@/assets/img/ferienhaus_debontje_greetsiel_garten_3.jpg"),
        require("@/assets/img/ferienhaus_debontje_greetsiel_terrasse_03.jpg")
      ]
    };
  }
};
</script>
